import React from "react";
export default function AlertMessage({ messages }) {


    return (
        <li className="connecting"> {messages.alert}</li>
        
    );
}
